import { screenSize } from '../../globals'

const regulationSizes = {
  paddingTablets: 135,
  paddingDesktop: 100,
  width: 1000,
}

export const constants = {
  commonGuideStyles: {
    overlay : {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 25,
    },
    content: {
      top: window.innerWidth <= screenSize.medium ? regulationSizes.paddingTablets : regulationSizes.paddingDesktop,
      left: window.innerWidth <= screenSize.specialSize ? 10 : 'auto',
      right: window.innerWidth <= screenSize.specialSize ? 10 : 'auto',
      bottom: 'auto',
      width: window.innerWidth <= screenSize.specialSize ? 'auto' : regulationSizes.width,
      maxWidth: window.innerWidth <= screenSize.specialSize ? 'auto' : regulationSizes.width,
      marginRight: 0,
      background: '#fff',
      padding: 0,
      border: 0,
      borderRadius: 0,
      boxShadow: '0px 0px 20px 3px rgba(0,0,0,0.8)',
      overflow: 'hidden',
    }
  },
  progressValues: [
    { value: 'Proposed', label: 'Proposed' },
    { value: 'Published', label: 'Published' },
    { value: 'Agency Adopted', label: 'Agency Adopted' },
    { value: 'Finally Adopted', label: 'Finally Adopted' },
    { value: 'Effective', label: 'Effective' },
    { value: 'Abandoned', label: 'Abandoned' },
    { value: 'Other Notices', label: 'Other Notices' },
    { value: 'Emergency', label: 'Emergency' },
  ],
  regulationTypeValues: [
    { regulationTypeId: '2', value: 'Regulation', label: 'Regulation' },
    { regulationTypeId: '21', value: 'Draft', label: 'Draft' },
    { regulationTypeId: '4', value: 'Bulletin/Memorandum', label: 'Bulletin/Memorandum' },
    { regulationTypeId: '3', value: 'Notice', label: 'Notice' },
    { regulationTypeId: '13', value: 'Press Release', label: 'Press Release' },
    { regulationTypeId: '10', value: 'Publication/Newsletter', label: 'Publication/Newsletter' },
    { regulationTypeId: '19', value: 'Docket', label: 'Docket' },
    { regulationTypeId: '5', value: 'Review', label: 'Review' },
    { regulationTypeId: '9', value: 'Meetings', label: 'Meetings' },
    { regulationTypeId: '6', value: 'Investigation', label: 'Investigation' },
    { regulationTypeId: '23', value: 'Request for proposal', label: 'Request for proposal' },
    { regulationTypeId: '7', value: 'Executive Order', label: 'Executive Order' },
    { regulationTypeId: '11', value: 'Report', label: 'Report' },
    { regulationTypeId: '14', value: 'Letter', label: 'Letter' },
    { regulationTypeId: '15', value: 'Opinion', label: 'Opinion' },
    { regulationTypeId: '16', value: 'Petition', label: 'Petition' },
    { regulationTypeId: '17', value: 'Application', label: 'Application' },
    { regulationTypeId: '18', value: 'Order', label: 'Order' },
    { regulationTypeId: '20', value: 'Guidance', label: 'Guidance' },
  ],
  historyValues: [
    { value: 'Adopted Rule filed on', label: 'Adopted' },
    { value: 'Advisory issued on', label: 'Advisory' },
    { value: 'Comment deadline', label: 'Comment' },
    { value: 'Emergency Rule filed on', label: 'Emergency filed' },
    { value: 'Emergency Rule effective on', label: 'Emergency effective' },
  ]
}



// WEBPACK FOOTER //
// ./src/components/AddRegulation/constants.js